<template>
    <div>
        <br>
        <v-container style="max-width:1024px">
            <v-card class="long-text grey--text text--darken-2">
                <div align="center">
                    <td style="padding-bottom: 8px">
                        <img src="../assets/404.png" class="center-img auto-downscale"><br>

                        <div v-if="this.language === 'de'">
                            <span style="padding-right:8px">Die Seite unter</span>
                            <span class="orange lighten-3 elevation-1">
                                {{ $route.path }}
                            </span>
                            <span style="padding-left:8px">wurde nicht gefunden.</span>

                            <div>
                                Sie werden <span v-if="redir > 0">in {{ redir }} Sekunde<span v-if="redir > 1">n</span></span> <span v-else>jetzt</span> auf die Homepage weitergeleitet.
                            </div>
                        </div>
                    </td>
                </div>

                <v-progress-linear warning v-model="prog"/>
            </v-card>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Unknown',
    created: function () {
        var path = this.$route.path;

        setTimeout(() => { this.countdown() }, 1000);
    },
    data () {
        return {
            // redirect
            redir: 3,
            prog: 0,
            countdown: function() {
                this.redir -= 1;
                this.prog = 100 - (this.redir / 3) * 100;

                if(this.redir === 0) {
                    setTimeout(() => { this.$router.push('/') }, 1000);
                } else {
                    setTimeout(() => { this.countdown() }, 1000);
                }
            },
        }
    },
    props: [ 'language' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::selection {
    background: #FFF2BC;
}
</style>



// WEBPACK FOOTER //
// 404.vue?06dfc6bb